var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#999",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.46,1.5H4.54a3,3,0,0,0-3,3V27.46a3,3,0,0,0,3,3H27.46a3,3,0,0,0,3-3V4.54A3,3,0,0,0,27.46,1.5ZM4.54,2.5H27.46a2,2,0,0,1,2,2v3H2.5v-3A2,2,0,0,1,4.54,2.5Zm22.92,27H4.54a2,2,0,0,1-2-2V8.5h27v19A2,2,0,0,1,27.46,29.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 5,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 5,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,14.5H14a.5.5,0,0,0-.5.5v7a.5.5,0,0,0,.5.5H18a.5.5,0,0,0,.5-.5V15A.5.5,0,0,0,18,14.5Zm-.5,7H14.53v-6h2.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.33,14.5a.5.5,0,0,0-.5.5v3.32H7.89V15a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v3.82a.51.51,0,0,0,.5.5h3.44V22a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V15A.5.5,0,0,0,11.33,14.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.61,14.5a.5.5,0,0,0-.5.5v3.32H21.17V15a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v3.82a.51.51,0,0,0,.5.5h3.44V22a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5V15A.5.5,0,0,0,24.61,14.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4905c42ec4b58ae8f99b93d1a8bd3835.svg";
export { ForwardRef as ReactComponent };